import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import { GestureHandling } from 'leaflet-gesture-handling';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconShadowUrl from 'leaflet/dist/images/marker-shadow.png';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';

// Base configuration for a Leaflet map
export default class BaseMapConfig {
    /**
     * @param {string} containerId - ID of the map container element
     * @param {[number, number]} center - LatLng center of the map
     * @param {number} zoom - Initial zoom level
     */
    constructor(containerId, center = [49.173913, -0.365814], zoom = 10) {
        this.containerId = containerId;
        this.center = center;
        this.zoom = zoom;
        this.token = 'pk.eyJ1IjoiZGV2aGlnaGZpdmUiLCJhIjoiY2sxdWg2anNzMDUyazNjbzZkaTNyczIzYSJ9.EOsWqX5_tCrq-CgS_3k9_Q';
        this.map = null;
        this.boundsGlobal = L.latLngBounds();
    }

    /**
     * Initialize common map options, icon defaults and tile layer
     */
    initMap() {
        // Remove default icon URL getter
        delete L.Icon.Default.prototype._getIconUrl;

        // Gesture handling plugin
        L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);

        // Set default icon images
        L.Icon.Default.mergeOptions({
            iconUrl,
            shadowUrl: iconShadowUrl,
        });

        // Create the map
        this.map = L.map(this.containerId, {
            gestureHandling: true,
        }).setView(this.center, this.zoom);

        // Add Mapbox satellite tiles
        L.tileLayer(
            `https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.jpg90?access_token=${this.token}`,
            { attribution: '&copy; OpenStreetMap contributors' }
        ).addTo(this.map);
    }

    /**
     * Fit map view to the global bounds
     */
    fitToBounds(padding = [20, 20]) {
        if (this.boundsGlobal.isValid()) {
            this.map.fitBounds(this.boundsGlobal, { padding });
        }
    }

    /**
     * Load cadastre data via WP AJAX and add to map
     * @param {number|string} postId
     * @param {object} WPData - global WPData config with ajaxUrl & nonce
     */
    async loadCadastreFromACF(postId, WPData) {
        try {
            const url = `${WPData.ajaxUrl}?action=get_parcelle&post_id=${postId}&nonce=${WPData.nonce}`;
            const res = await fetch(url);
            const json = await res.json();
            if (!json.success || !json.data || !Array.isArray(json.data.parcelle)) {
                throw new Error('Erreur récupération ACF ou format invalide');
            }

            for (const p of json.data.parcelle) {
                await this.addCadastre(p);
            }

            this.fitToBounds();
            document.querySelector('.map-load')?.classList.add('hidden');
            document.getElementById(this.containerId)?.classList.remove('hidden');

            setTimeout(() => {
                this.map.invalidateSize();
                this.fitToBounds();
                // this.map.once('moveend', () => this._exportAsImage());
                if (typeof this._exportAsImage === 'function') {
                    this.map.once('moveend', () => this._exportAsImage());
                }
            }, 200);
        } catch (e) {
            console.error('Erreur chargement ACF :', e);
        }
    }

    /**
     * Hash function for unique IDs
     */
    stringHash(str) {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return Math.abs(hash);
    }

    // Placeholder - implemented in subclasses
    async addCadastre(parcelle) {
        throw new Error('addCadastre must be implemented in subclasses');
    }
}